export const STORIES = [
  {
    id: "ontario-moonlight-01",
    author: "Sarah Chen",
    role: "Paddler",
    title: "City Lights & Moonlit Waters",
    excerpt: "A midnight journey to Toronto Island. The city skyline was a distant glow, and the only sound was the gentle ripple of my board. Pure magic.",
    image: "https://picsum.photos/seed/ontario-moonlight-story/800/600",
    date: "Nov 2025"
  },
  {
    id: "norway-peace-01",
    author: "Erik Jansson",
    role: "Nature Lover",
    title: "Fjord Serenity",
    excerpt: "Waking up to the mist rising off a Norwegian fjord. No rush, no noise. Just a slow morning coffee on my board, surrounded by giants.",
    image: "https://picsum.photos/seed/norway-peace-story/800/600",
    date: "Jan 2026"
  }
];

export const BRAND = {
  name: "Open Water Syndicate",
  shortName: "OWS",
  logo: "https://firebasestorage.googleapis.com/v0/b/gen-lang-client-0348624542.firebasestorage.app/o/assets%2Flogo_1776449835906%2F1776449835906_IMG_1495.png?alt=media&token=ce62125e-d0c3-4d6a-b515-efa81d9252cd",
  heroVideo: "", // Placeholder YouTube
  tagline: "The Water is Your Playground",
  description: "An invitation to unforgettable experiences. Limitless exploration. Serene mornings. Unforgettable sunsets.",
  founder: "Taras",
  founderTitle: "Explorer & Designer",
  colors: {
    teal: "#48CFCB",
    dark: "#2D3436",
    sand: "#FDFCFB",
    white: "#FFFFFF",
    orange: "#FF8C42",
    gold: "#FFD93D",
  },
  headlines: [
    "Wake Up to the Sound of Silence.",
    "Your Private Island, Anywhere You Choose.",
    "The Joy of the Open Water.",
    "Adventure Without Boundaries.",
    "Serenity Found on the Shore."
  ],
};

export const LEGACY_CONTENT = {
  title: "The Dream",
  subtitle: "A Journey of Freedom",
  body: "We built this for the moments that take your breath away. The calm lakes at dawn, the hidden coves, and the absolute freedom of being one with the water.",
  founder: "Taras",
  image: "https://picsum.photos/seed/taras-serenity/1200/800",
  milestones: [
    { year: "2023", event: "First Serene Crossing" },
    { year: "2024", event: "Discovering the Hidden Coast" },
    { year: "2025", event: "OWS EXPEDITION CX2: Perfected for the Journey" }
  ]
};

export const MANUAL_CONTENT = [
  {
    id: "effortless-gliding",
    title: "01. Effortless Gliding",
    subtitle: "Experience the grace of a displacement hull designed for smooth, peaceful journeys.",
    points: [
      "Displacement Hull Elegance: Gliding through the water with minimal effort.",
      "Perfect Tracking: Stay on your path to serenity without constant correction.",
      "Silent Motion: Designed to minimize water noise for a truly quiet escape.",
    ],
  },
  {
    id: "peace-of-mind",
    title: "02. Peace of Mind",
    subtitle: "Safety is silent. Our redundant core ensures your focus stays on the beauty of the horizon.",
    points: [
      "Dual-Chamber Confidence: Double the safety, double the relaxation.",
      "Reliable Design: Built to handle the unexpected so you don't have to worry.",
      "Unmatched Stability: A solid platform for yoga, meditation, or just drifting.",
    ],
  },
  {
    id: "floating-sanctuary",
    title: "03. Your Floating Sanctuary",
    subtitle: "Turning any shoreline into a 5-star retreat with air-cushioned comfort.",
    points: [
      "Air-Insulated Comfort: A soft, warm barrier between you and the elements.",
      "Versatile Basecamp: The perfect foundation for your lakeside afternoon.",
      "Seamless Integration: Designed to work perfectly with your favorite adventure gear.",
    ],
  },
  {
    id: "maintenance",
    title: "04. Gear Maintenance",
    subtitle: "The longevity of your vessel depends on proper care. Follow these protocols after every expedition.",
    points: [
      "Freshwater Rinse: Always wash down the hull and valves after salt water use.",
      "UV Protection: Store in shade when possible to maintain material integrity.",
      "Valve Inspection: Check seals and pressure relief valves monthly.",
    ],
  },
];

export const ACCESSORIES_LIST = [
  "1x 4-Section Carbon Fiber Paddle",
  "1x Solar-Integrated Waterproof Drybag Backpack",
  "1x Coiled Safety Leash & US Box Tri-Fin Set (1x 9\" center fin + 2x side fins for shallow water draft — all removable)",
  "1x Field Emergency Repair Kit"
];

export const BUNDLES = [
  {
    id: "ows-cx2-board-preorder",
    name: "OWS EXPEDITION CX2 Board Pre-Order",
    price: 999,
    items: [
      "OWS EXPEDITION CX2 Premium SUP Board",
      "Woven double-stitch & heat-fused 12'6\" flat deck structure",
      "Dual independent safety air chambers for survival redundancy",
      "V-shaped displacement nose hull architecture for optimized tracking",
      "Priority production batch build slot unit",
      "Fitted accessory kit: Carbon Paddle, Battery-Powered Pump, OWS Expedition Drybag-Backpack, Coiled Safety Leash",
      "12-Month continuous fleet warranty & technical support"
    ],
    featured: true,
    tag: "Production Batch 01",
  }
];

export const PREORDER_PACKAGES = [
  {
    id: "ows-cx2-board-preorder",
    name: "OWS EXPEDITION CX2 Board Pre-Order",
    price: 999,
    depositPrice: 299.70,
    balancePrice: 699.30,
    depositPercent: 30,
    description: "Option A Pre-Order Structure: $299.70 CAD ($220 USD*) 30% deposit due today to initiate pre-production build. Remaining $699.30 CAD ($515 USD*) 70% balance charged upon factory completion prior to Canada delivery. *USD estimates fluctuate with daily bank exchange rates.",
    items: [
      "OWS EXPEDITION CX2 Premium SUP Board",
      "Woven double-stitch & heat-fused 12'6\" flat deck structure",
      "V-shaped displacement nose hull architecture for optimized tracking",
      "Priority production batch build slot allocation",
      "Fitted accessory kit: Carbon Paddle, Battery-Powered Pump, OWS Expedition Drybag-Backpack, Coiled Safety Leash",
      "12-Month continuous fleet warranty & technical support"
    ],
    featured: true,
    tag: "Option A: 30% Deposit ($299.70 CAD / ~$220 USD*)",
  }
];

export const CX2_EXPEDITION_SPECS = {
  dimensions: "12’6\" × 32\" × 6\"",
  capacity: "408 lbs (185 kg)",
  construction: "Heat-fused dual-layer industrial grade PVC",
  core: "2600g/m² knitted drop-stitch",
  pressure: "12–15 PSI recommended — 20 PSI maximum",
  hull: "V-shaped nose geometry",
  chambers: "Dual independent air chambers",
  color: "Navigation White",
};

export const CX2_SPECS = {
  length: "12’6\"",
  width: "32\"",
  thickness: "6\"",
  weight: "28 lbs (12.7 kg)",
  volume: "350L",
  dimensions: "12’6\" × 32\" × 6\"",
  capacity: "408 lbs (185 kg)",
  construction: "Heat-fused dual-layer industrial grade PVC",
  core: "2600g/m² knitted drop-stitch",
  pressure: "12–15 PSI recommended — 20 PSI maximum",
  hull: "V-shaped nose geometry",
};

export const FEATURED_EXPEDITIONS = [
  {
    id: "toronto-islands-night",
    title: "Toronto Islands Night Raid",
    location: "Toronto, ON",
    description: "Navigate the inner lagoons under the city lights. A surreal urban wilderness experience.",
    image: "https://picsum.photos/seed/toronto-night/800/600",
    duration: "4 Hours",
    difficulty: "Intermediate"
  },
  {
    id: "georgian-bay-hidden",
    title: "Georgian Bay Hidden Coves",
    location: "Ontario, Canada",
    description: "Crystal clear waters and pink granite islands. The Caribbean of the North.",
    image: "https://picsum.photos/seed/georgian-bay/800/600",
    duration: "3 Days",
    difficulty: "Advanced"
  }
];

export const APPROVED_GEAR = [
  {
    id: "ows-cx2-outpost",
    name: "OWS EXPEDITION CX2-Outpost",
    brand: "OWS",
    category: "Shelter",
    description: "The world's first tent that turns your SUP into a camper. OWS Approved for OWS EXPEDITION CX2.",
    image: "https://picsum.photos/seed/ows-c2-outpost/600/600",
    price: "$599",
    link: "/manual#floating-sanctuary"
  },
  {
    id: "garmin-inreach",
    name: "inReach® Mini 2",
    brand: "Garmin",
    category: "Safety",
    description: "Satellite communication for when you're off the grid. Essential for open water crossings.",
    image: "https://picsum.photos/seed/garmin-inreach/600/600",
    price: "$399",
    link: "https://www.garmin.com/en-US/p/765374"
  },
  {
    id: "yeti-panga",
    name: "Panga® 28L Backpack",
    brand: "YETI",
    category: "Storage",
    description: "100% waterproof submersible backpack. Keeps your gear dry in any conditions.",
    image: "https://picsum.photos/seed/yeti-panga/600/600",
    price: "$299",
    link: "https://www.yeti.com/bags/backpacks/panga-backpack-28l.html"
  }
];

export const COMPARISON_TABLE = [
  { feature: "Bracing Potential", ows: "32\" Flat Deck (Rail to Rail Stability)", standard: "Raised side chambers (Forces feet to center)" },
  { feature: "Nose Geometry", ows: "V-Hull (Cuts water, acts as keel)", standard: "Flat bottom (Plows water, causes drag)" },
  { feature: "Structural Integrity", ows: "Dual Chamber Spine (Eliminates taco-flex)", standard: "Single Chamber (Bends/paddles like hammock)" },
  { feature: "Safety Redundancy", ows: "Fully Independent Chambers", standard: "Single point of failure (Rescue situation risk)" },
  { feature: "Thermal Stability", ows: "Navigation White (Heat reflective)", standard: "Dark decks (Absorb heat, seams creep)" },
];

export const EXPEDITION_LOGS = [
  {
    id: "isla-espiritu-santo",
    title: "Isla Espíritu Santo & Isla Partida",
    location: "BCS, Mexico",
    date: "November Expedition",
    type: "Open Ocean Crossing",
    teaser: "Two islands off the coast of Baja, connected by a narrow passage, ringed by open ocean. No roads. No shortcuts. The kind of geography that asks a specific question.",
    image: "https://picsum.photos/seed/baja-expedition/1200/800",
    days: [
      {
        day: "DAY 1",
        title: "THE BEGINNING",
        content: `The map had been sitting on my desk for three months before I admitted it was a plan. That's how it always starts — not with a decision but with an image you can't stop returning to. Two islands off the coast of Baja, connected by a narrow passage, ringed by open ocean. No roads. No shortcuts. The kind of geography that asks a specific question: are you actually going to do this, or are you just going to keep looking at it?

One by one, the team formed. People who said yes when most would have said you're out of your mind. People who understood that real adventures begin exactly where the reasonable answer ends.

We weren't rookies. Three Lake Ontario crossings between us — we knew what it meant to paddle for hours without seeing shore, to fight headwinds and side chop, to find that threshold where the body wants to stop and decide it won't. But this was different. For the first time, we were heading into real open ocean. No city lights behind us, no safety boat running parallel, no version of this that was anything less than the full thing.

We prepared the way we always do: properly. Boards, gear, food, water, portable desalination unit. Everything checked twice. Windy App showed heavy wind forecasted for Day Two on the west side of Espíritu Santo — our emergency contact Niko warned waves could hit a meter. Not ideal. But if it were all predictable, there'd be no point going.

We landed in Cabo, set up Casa Velas as a gear lab. Pumps, fins, valves, dry bags across every surface. At 3 a.m., Alex arrived — our driver, half-asleep and smiling. We loaded the boards and moved into the dark.`
      },
      {
        day: "THE FIRST CROSSING",
        title: "PLAYA BONANZA",
        content: `Three hours to Playa Tecolote. We arrived at dawn — soft light, the water so still it looked solid. A light breeze pushed north toward the island. We inflated the boards, loaded provisions, tightened every strap. One last handshake with Alex, one last breath of stable ground — then the first paddle stroke. One of thousands ahead.

The route showed 8–9 km to Playa Bonanza. Straightforward on paper. Paper omits the wind. My Garmin tracked numbers — distance, heading, speed — but instinct handled the rest. Lake Ontario had taught me to read water by feel, and something kept saying: we're good. Like every crossing before this had been practice for this one moment.

We moved through the channel between mainland and island, and the water came alive beneath us — fish, shadows, quick flashes under the boards. We rounded the first cape and the west side of Espíritu Santo revealed itself: five kilometers of clean, untouched sand and turquoise. Playa Bonanza. No noise, no other people. The desert island rising behind the beach like a promise kept.

We jumped in. Cold shock, perfect visibility, more marine life than expected. A few jellyfish — nothing the rashguards couldn't handle.

Then the wind found us. It started slowly, then climbed like someone turning a dial. Gusts hit 20 km/h. The cove held back any real swell, but the resistance was constant. Armando and I rode touring boards — the narrow, pointy hull I always call the "dictator line," because pointy is scary and commitment is mandatory. Dave was carrying half our provisions on a round board: heavy load, wrong shape, gusts catching the bow. That combination makes its own kind of adventure.`
      },
      {
        day: "ARRIVAL",
        title: "PLAYA BONANZA",
        content: `We unloaded everything under the tree and finally exhaled. Dave boiled water, opened the dehydrated food. It tasted better than most restaurant meals. That's what genuine hunger does to flavor.

At the north end of the beach, another group had claimed the sand — identical tents, older tourists soaking up sun. They weren't happy to see us. Turned away, avoided any acknowledgment. It didn't matter. In a place like this, money has no weight. Water is the currency, and only when it's shared from a good heart. We had enough.

We explored the shoreline, returned to the tree. Tents were set at respectful distance from one another — managing the nightly snoring choir is a genuine tactical consideration on expeditions. The sun dropped behind the ridges and painted the mountains gold. Warm air, quiet beach, boards resting on sand, everything decelerating at once.

We lit the first cigar of the trip — a ritual we'd carry through every camp, the way other people say grace. We told stories, laughed, agreed on 5:15 a.m.

That night I had one of the most vivid dreams of my life. I was lying in the tent, looking out at the open sand, when a tiger walked past — unhurried, enormous, completely real. Calm the way only something that fears nothing is calm. I lay still and watched it go. Maybe the island was already getting inside my head. Either way, it stayed with me.`
      },
      {
        day: "DAY 2",
        title: "INTO THE DEEP",
        content: `The alarm went off in total darkness. Dave passed me a sip of instant coffee — the expedition sacrament, never skipped — and we broke down camp. Boards packed, dry bags sealed, sand swept clean. Leave No Trace isn't a rule out here so much as a debt. You take nothing from the island and you leave nothing behind.

Before leaving Toronto I'd studied these charts until I could see them with my eyes closed. Today we were heading over 600 meters of open water. A whole silent world beneath us, permanently out of reach. The sea surface was glass. It felt like an invitation.

An expedition like this offers one consistent truth: you never know what waits around the next cape. But something kept repeating in my chest as we paddled — the island accepted us. She'll show us what she wants to show.

Cape after cape. Cliffs rising above us, massive and entirely indifferent. The water deepened as we moved away from shore. We had to feel it — so we jumped. Straight into 600 meters of blue. Cold and honest. Fish moved around us, unafraid, curious, going about their morning like we were simply another species passing through.

Three km to Playa Partida. We paddled on. The two islands split ahead of us — a narrow channel between them, and beyond it a rocky beach scattered with medium stones. From a distance, it looked like a difficult landing. "Are we gonna have to portage this?" Dave called out. "Pass the rocks on the left," I said.

And it opened. No obstacle, no drama — a clean gap in the rocks leading to a long pale beach, maybe 500 meters of untouched sand. Soft dunes behind it. A small lagoon sitting perfectly still. A fisherman's shed at the edge, waiting there like it always had been.`
      },
      {
        day: "AFTERNOON",
        title: "PLAYA PARTIDA",
        content: `Into the water immediately. Small jellyfish drifting past, rashguards doing their job. Swimming along the rock face, we found formations that functioned as entire neighborhoods for fish — dense, layered, alive. A small moray eel appeared and held its ground. Nothing here seemed to know what fear was.

Then a rock moved. A large oyster, reacting to my shadow, pulling itself shut. I worked one loose with the handle of my Insta360 and held it up. "Who wants an oyster?" Dave: immediately yes. Armando — not a seafood person — was an immediate, firm no.

Armando had bought a proper oyster knife in La Paz. He tried to open one and cut himself on the shell. I took over: small rock, one tap at the hinge, slide through the main muscle. It opened clean. We rinsed them in the sea, squeezed lime over the top. The freshest oysters I've ever eaten — pulled from water that hadn't been touched.

The sun was brutal. Dave built a shade shelter using two boards as a frame, draped with our microfiber towels. It worked. The man has a talent for improvised architecture.

By 5:30 the light was gone behind the mountains — the sky turning gold, then orange, then out. We made camp, shot a timelapse of the horizon, and the Milky Way came up like a reminder that most of what exists is not the city.`
      },
      {
        day: "DAY 3",
        title: "PLAYA EMBUDO",
        content: `Before sunrise again. The Windy App had predicted trouble for this stretch. The sea gave us glass — completely flat, the kind of morning that justifies every early alarm. We packed and pushed off without ceremony.

Cape after cape, the island's architecture revealed itself: ancient cliffs, caves worn through by centuries of swell, layers of rock that read like the compressed history of this place. We slipped into the water whenever the depth below us became impossible to ignore — each time a reminder that what we floated over was only the surface of something enormous.

Rounding a point, a small rocky islet appeared about 500 meters ahead — one of the largest sea lion colonies in this stretch of the Vermilion Sea. This was a primary goal. We headed toward it. Tour boats were moored to designated buoys. One had just dropped off a group of snorkelers. We asked if we could tie up and join them — permission granted. We suited up and slipped in.

A massive male was posted on the rocks at the entrance. We held our distance. Further in, a deep cave opened in the rock face, and inside it young sea lions were moving through the water — spinning, darting, folding and unfolding around us with total ease. Playing is the closest word. They circled us like we were a mildly interesting obstacle and then forgot we were there.`
      },
      {
        day: "DAY 4",
        title: "TOWARD PLAYA CANDELERO",
        content: `We woke when we woke. Cleaned the beach, packed everything, pushed off into steady headwind — not dangerous, but the kind that makes you earn each kilometer, that gives you nothing for free.

The map showed a freshwater well at the next inlet. I was down to 1.5 liters. The desalination unit had proven genuinely difficult to operate under expedition conditions. A natural source was the priority. The inlet was short and shallow — a notch cut between two rock faces. We beached and followed a narrow pass inland. Less than a kilometer in, Armando spotted the well. He and Dave ran ahead. I read the answer in their faces before I reached them. Six meters deep, with water at the bottom — and something dead in it. We shouldered our bags.

The cliffs along this stretch were immense. At the narrow passage dividing Isla Partida from Isla Espíritu Santo, I stopped and looked back at the island we were leaving. "Hasta la vista, Partida," I said quietly. "I hope to see you again."

Espíritu Santo rose ahead — layered stone walls, ancient and unhurried. Then a natural arch appeared in the rock. Before we left La Paz, Alex had told us: when you see the arch, go under it and make a wish. I paddled through first and wished for peace inside myself.

That moment was why we came. Not the distance, not the cliffs, not the campfires or the oysters or the 3 a.m. departures. That moment — floating in open ocean while something wild chose, of its own free will, to share it with you. That's the thing expeditions are made for. The rest is just the path to get there.`
      }
    ]
  }
];
